"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMessageListener = void 0;
var web_page_orchestrator_1 = require("@bookingcom/web-page-orchestrator");
var constants_1 = require("../constants");
var setMessageListener = function () {
    if (constants_1.isClient) {
        var orchestrator_1 = (0, web_page_orchestrator_1.getOrchestrator)();
        window.addEventListener('message', function (e) {
            var message = e.data;
            switch (message.type) {
                case 'MP_ADD_PRODUCT': {
                    var payload = message.payload;
                    orchestrator_1 === null || orchestrator_1 === void 0 ? void 0 : orchestrator_1.runCommand('MP_ADD_PRODUCT', payload);
                    break;
                }
                case 'MP_REMOVE_PRODUCT': {
                    var payload = message.payload;
                    orchestrator_1 === null || orchestrator_1 === void 0 ? void 0 : orchestrator_1.runCommand('MP_REMOVE_PRODUCT', payload);
                    break;
                }
                case 'MP_UPDATE_IFRAME_HEIGHT': {
                    // Note: this is handled by the MpIframe component
                    // because it's specific to the iframe HTML element
                    break;
                }
                case 'MP_SEND_C360_EVENT': {
                    var payload = message.payload;
                    orchestrator_1 === null || orchestrator_1 === void 0 ? void 0 : orchestrator_1.runCommand('MP_SEND_C360_EVENT', payload);
                    break;
                }
                default: {
                    break;
                }
            }
        });
    }
};
exports.setMessageListener = setMessageListener;
